export const CAPTION = `WEBVTT`;
export const CAPTION_HEADER = `WEBVTT FILE`;
export const PLACEHOLDER = `{xazqby}`;
// Temporary kill switch: hides captions in every video player. Set to false to restore.
export const CAPTIONS_DISABLED = true;
export const isCdkEnvironment = import.meta.env.VITE_WHITELABEL_NAME === 'cdk';

export const VAULT_FOLDER = 'vault';
